/**
 * Shared Hooks - Main Exports
 */

// Form hooks
export { useFormValidation } from './form/use-form-validation';

// Navigation hooks
export { useRouteNavigation } from './navigation/useRouteNavigation';
export { useSubNavbar } from './navigation/useSubNavbar';

// Performance hooks
export { usePerformanceMonitor } from './performance/usePerformanceMonitor';
export { useServiceWorker } from './performance/useServiceWorker';

// Scroll hooks
export { default as useCustomSmoothScroll } from './scroll/useCustomSmoothScroll';
export { default as useElementSmoothScroll } from './scroll/useElementSmoothScroll';

// Session hooks
export { useSession } from './session/useSession';

// Theme hooks
export { useStableColorSchema } from './theme/useStableColorSchema';
